<!--  -->
<template>
    <div class="filingApplication">
        <div class="margin-bottom">
            <lazy-load-list ref="lazyLoadList" :getData="initData" :description="'暂无您的优惠认证申请'" :query="query">
                <template v-slot="slotData">
                    <div v-for="(item,index) in slotData.dataList" :key='index' class="list-item">
                        <div style="flex: 1">
                            <div class="list-item-top" @click="toDetail(item)">
                                <div class="list-item-top-left text-cut">
                                    <!-- <img class="img" src="@/assets/images/home/head.png" /> -->
                                    {{ item.plateNum }}
                                </div>
                                <!-- 审核状态  1 未审核 2 审核中 3 已认证 4 驳回 -->
                                <div>

                                    <div v-if="item.status == 2" class="size status-two">审核中</div>
                                    <div v-else-if="item.status == 3" class="size status-three">审核通过</div>
                                    <div v-else-if="item.status == 4" class="size status-four">审核不通过</div>
                                    <!-- <div v-else-if="item.status == 3" class="size status-four">已撤办</div> -->

                                    <div v-else class="size status-five">关闭</div>
                                </div>
                            </div>
                            <div class="list-item-content">
                                <div>手机号码：{{ item.phoneNo }}</div>
                                <div>申请时间：{{ item.createTime }}</div>
                            </div>
                            <div class="list-item-bottom delete" @click="revoke(item)" v-if="item.processStatus == 1">
                                撤 办
                            </div>

                        </div>
                    </div>
                </template>
            </lazy-load-list>

        </div>
        <div class="bottom">
            <van-button icon="plus" block class="bottom-button" @click="toDetail({})">添加认证
            </van-button>
        </div>
    </div>
</template>

<script>
import LazyLoadList from '@/components/base/lazyLoadList/lazy-load-list.vue'
import { listAuth, revocationFilingApply } from '@/api/api'

import DialogBox from "@/components/base/dialog/dialog.js";
export default {
    name: 'FilingApplication',
    components: {
        LazyLoadList
    },

    data() {
        return {
            query: {

                pageNum: 0,
                pageSize: 10
            }
        }
    },

    computed: {},

    mounted() { },

    methods: {
        // 给子组件使用
        initData() {
            return listAuth(this.query)
        },
        // 详情
        toDetail(item) {
            this.$router.push({
                path: '/mine/preferentialCertification/addCertification',
                query: item
            })
        },

        revoke(item) {
            let that = this;
            DialogBox(
                {
                    content: `是否撤办当前备案？`,
                    leftBtnText: "取消",
                    rightBtnText: "确定",
                    rightBtnClick() {
                        revocationFilingApply({ id: item.id }).then(res => {
                            that.$toast('撤办成功！')
                            that.$refs.lazyLoadList.refreshing = true
                            that.$refs.lazyLoadList.onLoad()
                        })
                    },
                }
            )
        }

    }
}

</script>
<style lang="less" scoped>
// @import url("../../assets/style/base.less");

.delete {
    color: #fb1818;
}

.bottom-text {
    color: #969799;
    width: 100%;
    padding: 0 5%;
    position: absolute;
    bottom: 140px;
}

.filingApplication {
    background-color: #f7f7f7;
    height: 100vh;
    overflow: auto;

    .bottom {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        position: fixed;
        bottom: 0;
        padding: 20px 0;
        background-color: #fff;

        .bottom-button {
            background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
            color: #fff;
            width: 702px;
            height: 80px;
            border-radius: 16px;
            font-size: 32px;
        }
    }
}

.list-item {
    min-height: 190px;
    width: 702px;
    border-radius: 10px;
    background-color: #fff;
    margin: 16px auto 0 auto;
    padding: 0 24px 10px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .list-item-left {
        img {
            height: 128px;
            width: 168px;
            border-radius: 20px;
        }

        margin-right: 24px;
    }

    .list-item-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 93px;
        border-bottom: 1px rgba(0, 0, 0, 0.1) solid;

        .list-item-top-left {
            color: #303133;
            font-size: 32px;
            width: 520px;
            display: flex;
            align-items: center;

            .img {
                height: 32px;
                width: 32px;
                margin-right: 20px;
            }
        }

        .list-item-top-right {
        }

        .size {
            display: flex;
            align-items: center;
            height: 40px;
            padding: 5px;
            font-size: 24px;
            border-radius: 10px;
        }

        .status-one {
            color: #ff9834;
            border: 1px #ff9834 solid;
            background-color: #fff0e1;
        }

        .status-two {
            color: #2496fb;
            border: 1px #2496fb solid;
            background-color: #d9eefe;
        }

        .status-three {
            color: #73c383;
            border: 1px #73c383 solid;
            background-color: #e5f4e8;
        }

        .status-four {
            color: #fb1818;
            border: 1px #fb1818 solid;
            background-color: #fed9d9;
        }

        .status-five {
            color: #a2a2a2;
            border: 1px #a2a2a2 solid;
            background-color: #f0f0f0;
        }
    }

    .list-item-content {
        min-height: 190px;
        color: #333;
        font-size: 28px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        font-family: SourceHanSansCN-Normal;
        padding: 10px 0;
    }

    .list-item-middle {
        margin-top: 10px;
        color: #606266;
        font-size: 28px;
    }

    .list-item-bottom {
        width: 100%;
        height: 74px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        border-top: 1px rgba(0, 0, 0, 0.1) solid;
        font-size: 28px;

        img {
            width: 28px;
            height: 28px;
            margin-right: 10px;
        }
    }
}

.margin-bottom {
    overflow: scroll;
    height: calc(100vh - 120px - 130px);
    margin-bottom: 130px;
}
</style>
